import en from './en';
import ta from './ta';
import hi from './hi';
import kn from './kn';
import withFallback from './withFallback';

/**
 * Language registry — single source of truth.
 *
 * To add a new language (e.g., Malayalam):
 *   1. Create src/i18n/ml.js with translation keys
 *   2. Import it above
 *   3. Add entry to LANGUAGES below
 *   4. Add to `raw` object
 *   Done — UI picks it up automatically.
 */
export const LANGUAGES = [
  { code: "en", name: "English", native: "English", rtl: false },
  { code: "ta", name: "Tamil", native: "தமிழ்", rtl: false },
  { code: "hi", name: "Hindi", native: "हिन्दी", rtl: false },
  { code: "kn", name: "Kannada", native: "ಕನ್ನಡ", rtl: false },
];

const raw = { en, ta, hi, kn };

// English is used as-is; all others wrapped with fallback to English
const T = {};
LANGUAGES.forEach(l => {
  T[l.code] = l.code === "en" ? en : withFallback(raw[l.code], en);
});

export default T;
